import React from "react";
import { H3} from "../../AbstractElements";
import FeatureContainer from "../../Layout/Containers/FeatureContainer";

const PanduanPenggunaan = () => {
  return (
    <FeatureContainer title={"Panduan"} subtitle={"Panduang Penggunaan"}>
      <H3>Panduan Penggunaan</H3>

      <a href="https://s.id/panduan-kepegawaian" target="_blank" rel="noreferrer">
      https://s.id/panduan-kepegawaian
      </a>
      <br />
      <br />
      <br />
      <br />
      <H3>FAQ Panduan</H3>

      <a href="https://s.id/panduan-kepegawaian" target="_blank" rel="noreferrer">
      https://s.id/panduan-kepegawaian
      </a>
    </FeatureContainer>
  );
};
export default PanduanPenggunaan;
